import Validation from '@/modules/validation.js'

class Authenticate {
    constructor() {}

    login = () => {
        new Validation({
            rules: {
                email: {
                    required: true,
                    email: true
                },
                password: {
                    required: true
                }
            }
        }).validator()
    }
}

window.Authenticate = () => new Authenticate